@if (useCompactLayout) {
  <div class="card card-animate stat-compact">
    <div class="card-body d-flex align-items-center">
      @if ((secondaries?.length ?? 0) <= 1) {
      <div class="avatar-sm flex-shrink-0 me-3 stat-compact-icon">
        <span class="avatar-title rounded fs-4"
              [ngClass]="iconColour ? ('bg-' + iconColour + '-subtle') : {
                            'bg-danger-subtle' : icon === 'bi bi-award-fill' ||
                                                 icon === 'bi bi-bookmark-x' ||
                                                 icon === 'bi bi-exclamation-triangle' ||
                                                 icon === 'bi bi-exclamation-triangle-fill' ||
                                                 icon === 'bi bi-exclamation-circle' ||
                                                 icon === 'bi bi-exclamation-circle-fill',
                            'bg-info-subtle'   : icon === 'bi bi-sim' ||
                                                 icon === 'bi bi-award' ||
                                                 icon === 'bx-shopping-bag',
                            'bg-primary-subtle': icon === 'bxs-building' ||
                                                 icon === 'bi bi-tablet' ||
                                                 icon === 'bx-wallet' ||
                                                 icon === 'bx-phone',
                            'bg-success-subtle': icon === 'bi bi-bookmark-check' ||
                                                 icon === 'bi bi-check-circle' ||
                                                 icon === 'bxs-business' ||
                                                 icon === 'bx-pound' ||
                                                 icon === 'bx-dollar-circle',
                            'bg-warning-subtle': icon === 'bx-battery' ||
                                                 icon === 'bx-line-chart' ||
                                                 icon === 'bx-user-circle'
                          }">
          <i class="bx {{icon}}"
             [ngClass]="iconColour ? ('text-' + iconColour) : {
                           'text-danger' : icon === 'bi bi-award-fill' ||
                                           icon === 'bi bi-bookmark-x' ||
                                           icon === 'bi bi-exclamation-triangle' ||
                                           icon === 'bi bi-exclamation-triangle-fill' ||
                                           icon === 'bi bi-exclamation-circle' ||
                                           icon === 'bi bi-exclamation-circle-fill',
                           'text-info'   : icon === 'bi bi-sim' ||
                                           icon === 'bi bi-award' ||
                                           icon === 'bx-shopping-bag' ||
                                           icon === 'bx-phone',
                           'text-primary': icon === 'bxs-building' ||
                                           icon === 'bi bi-tablet' ||
                                           icon === 'bx-wallet',
                           'text-success': icon === 'bi bi-bookmark-check' ||
                                           icon === 'bi bi-check-circle' ||
                                           icon === 'bxs-business' ||
                                           icon === 'bx-pound' ||
                                           icon === 'bx-dollar-circle',
                           'text-warning': icon === 'bx-battery' ||
                                           icon === 'bx-line-chart' ||
                                           icon === 'bx-user-circle'
                         }"></i>
        </span>
      </div>
      }

      <div class="flex-grow-1 overflow-hidden">
        <p class="text-uppercase fw-semibold text-muted text-truncate mb-1 stat-compact-title"
           [innerHTML]="title">
        </p>

        @if (subTitle) {
          <p class="text-uppercase fw-semibold text-muted text-truncate mb-0 stat-title-line4"
             [innerHTML]="subTitle">
          </p>
        }

        @if (loading) {
          <p class="fw-medium text-muted text-truncate mb-0 small"><i>Loading...</i></p>
        }
        @else {
          <div class="d-flex align-items-baseline flex-wrap" style="gap: 0.5rem;">
            @if (isNumber(value) == false) {
              <h4 class="mb-0 fw-bold stat-compact-value">
                <span>{{value}}</span>
              </h4>
            }
            @else {
              <h4 class="mb-0 fw-bold stat-compact-value"
                  [class.stat-h4-stacked]="(secondaries?.length ?? 0) > 1">
                <span class="stat-cell">
                  @if (prefix) {
                    <span>{{prefix}}</span>
                  } @else if (title==statTitleTotalCostsUsage ||
                              title==statTitleTotalCostsUsageAndLicence ||
                              title==statTitleTotalCostsUsageCustomer ||
                              title==statTitleTotalCostsUsageNotInc ||
                              title==statTitleTotalCostsLicence ||
                              title==statTitleTotalCostsLicenceNotInc ||
                              title==statTitleTotalProfitUsage ||
                              title==statTitleTotalPurchaseCostsUsage ||
                              title==statTitleTotalSimProfitLicencesCost ||
                              title==statTitleTotalSimProfitSimBuyCosts ||
                              title==statTitleTotalSimProfitTotalProfit) {
                    <span>£</span>
                  }

                  @if (useCountUp) {
                    <span [countUp]="effectiveValue" class="counter-value" [options]="option"></span>
                  } @else {
                    <span class="counter-value">{{ effectiveValue | number: digitsInfo }}</span>
                  }

                  @if (isGbUsageStat) {
                    <span>{{usageDisplayUnitLabel}}</span>
                  } @else if (unit) {
                    <span>{{unit}}</span>
                  }

                  @if (showProfit && hasPercentage && (secondaries?.length ?? 0)>0) {
                    <span class="stat-pct ms-1 small fw-semibold stat-compact-profit"
                          [ngClass]=" {
                                        'text-success': (profitUpIsGood && profit==='up'  ) || (!profitUpIsGood && profit==='down'),
                                        'text-danger' : (profitUpIsGood && profit==='down') || (!profitUpIsGood && profit==='up'  ),
                                        'text-muted'  : profit==='equal'
                                      }">
                      <i class="align-middle" [ngClass]=" {'ri-arrow-right-up-line': profit === 'up', 'ri-arrow-right-down-line': profit === 'down'}"></i>
                      @if (profit == 'up' || profit == 'equal') {
                        <span>+</span>
                      }
                      {{percentage}} %
                    </span>
                  }
                </span>

                @for (sec of secondaries; track $index) {
                  <span class="stat-secondary fw-semibold ms-2">
                    <span class="stat-cell">
                      <span class="text-muted">+</span>
                      <span class="ms-2">{{sec.prefix}}{{ sec.value | number: digitsInfo }}</span>
                      <span class="stat-pct ms-1 small fw-semibold stat-compact-profit"
                            [ngClass]=" {
                                          'text-success': (sec.profitUpIsGood && sec.profit==='up'  ) || (!sec.profitUpIsGood && sec.profit==='down'),
                                          'text-danger' : (sec.profitUpIsGood && sec.profit==='down') || (!sec.profitUpIsGood && sec.profit==='up'  ),
                                          'text-muted'  : sec.profit==='equal'
                                        }">
                        <i class="align-middle" [ngClass]=" {'ri-arrow-right-up-line': sec.profit === 'up', 'ri-arrow-right-down-line': sec.profit === 'down'}"></i>
                        @if (sec.profit == 'up' || sec.profit == 'equal') {
                          <span>+</span>
                        }
                        {{sec.percentage}} %
                      </span>
                    </span>
                  </span>
                }
              </h4>
            }

            @if (showProfit == true && hasPercentage && (secondaries?.length ?? 0)===0) {
              <span class="small fw-semibold stat-compact-profit"
                    [ngClass]=" {
                                  'text-success': (profitUpIsGood && profit==='up'  ) || (!profitUpIsGood && profit==='down'),
                                  'text-danger' : (profitUpIsGood && profit==='down') || (!profitUpIsGood && profit==='up'  ),
                                  'text-muted'  : profit==='equal'
                                }">
                <i class="align-middle" [ngClass]=" {'ri-arrow-right-up-line': profit === 'up', 'ri-arrow-right-down-line': profit === 'down'}"></i>
                @if (profit == 'up' || profit == 'equal') {
                  <span>+</span>
                }
                {{percentage}} %
              </span>
            }

            @if (linkText) {
              <a [routerLink]="link" class="text-success small fw-semibold stat-compact-link">{{linkText}}</a>
            }
          </div>
        }
      </div>
    </div>
  </div>
}
@else {
  <div class="">
    <div class="card card-animate">
      <div class="card-body">
        <div class="d-flex align-items-center">
          <div class="flex-grow-1 overflow-hidden">
            <p
              class="text-uppercase fw-semibold text-primary text-truncate mb-0 stat-title"
              [innerHTML]="title"
            >
            </p>

            @if (subTitle) {
              <p
                class="text-uppercase fw-semibold text-primary text-truncate mb-0 stat-title-line4"
                [innerHTML]="subTitle"
              >
              </p>
            }
          </div>

          @if(showProfit == true && hasPercentage && (secondaries?.length ?? 0)===0) {
          <div class="flex-shrink-0">
            <h5
              class="fs-14 mb-0"
              [ngClass]=" {
                'text-success': (profitUpIsGood && profit==='up'  ) || (!profitUpIsGood && profit==='down'),
                'text-danger' : (profitUpIsGood && profit==='down') || (!profitUpIsGood && profit==='up'  ),
                'text-muted'  : profit==='equal'
              }"
            >
              <i class="fs-13 align-middle float-start" [ngClass]=" {'ri-arrow-right-up-line': profit === 'up', 'ri-arrow-right-down-line': profit === 'down'}"></i>
              @if(profit == 'up' || profit == 'equal') {
                <span>+</span>
              } <!-- @else {
                <span>-</span>
              } -->
              {{percentage}} %
            </h5>
          </div>
          }

        </div>
        <div class="d-flex align-items-end justify-content-between mt-4">
          <div>
            @if(loading) {
              <p class="fw-medium text-muted text-truncate mb-4"><i>Loading...</i></p>
            }
            @else if(isNumber(value) == false) {
              <h4 class="fs-22 fw-semibold ff-secondary mb-4">
                <span>{{value}}</span>
              </h4>
            }
            @else {
              <h4 class="fs-22 fw-semibold ff-secondary mb-4"
                  [class.stat-h4-stacked]="(secondaries?.length ?? 0) > 1">
                <span class="stat-cell">
                  @if(prefix) {
                    <span>{{prefix}}</span>
                  } @else if(title==statTitleTotalCostsUsage ||
                      title==statTitleTotalCostsUsageAndLicence ||
                      title==statTitleTotalCostsUsageCustomer ||
                      title==statTitleTotalCostsUsageNotInc ||
                      title==statTitleTotalCostsLicence ||
                      title==statTitleTotalCostsLicenceNotInc ||
                      title==statTitleTotalProfitUsage ||
                      title==statTitleTotalPurchaseCostsUsage ||
                      title==statTitleTotalSimProfitLicencesCost ||
                      title==statTitleTotalSimProfitSimBuyCosts ||
                      title==statTitleTotalSimProfitTotalProfit) {
                    <span>£</span>
                  }

                  @if (useCountUp) {
                    <span [countUp]="effectiveValue" class="counter-value" [options]="option"></span>
                  } @else {
                    <span class="counter-value">{{ effectiveValue | number: digitsInfo }}</span>
                  }

                  @if(isGbUsageStat) {
                    <span>{{usageDisplayUnitLabel}}</span>
                  } @else if(unit) {
                    <span>{{unit}}</span>
                  }

                  @if (showProfit && hasPercentage && (secondaries?.length ?? 0)>0) {
                    <span class="stat-pct ms-2 fs-14 fw-semibold"
                          [ngClass]=" {
                                        'text-success': (profitUpIsGood && profit==='up'  ) || (!profitUpIsGood && profit==='down'),
                                        'text-danger' : (profitUpIsGood && profit==='down') || (!profitUpIsGood && profit==='up'  ),
                                        'text-muted'  : profit==='equal'
                                      }">
                      <i class="align-middle" [ngClass]=" {'ri-arrow-right-up-line': profit === 'up', 'ri-arrow-right-down-line': profit === 'down'}"></i>
                      @if (profit == 'up' || profit == 'equal') {
                        <span>+</span>
                      }
                      {{percentage}} %
                    </span>
                  }
                </span>

                @for (sec of secondaries; track $index) {
                  <span class="stat-secondary fw-semibold ms-2">
                    <span class="stat-cell">
                      <span class="text-muted">+</span>
                      <span class="ms-2">{{sec.prefix}}{{ sec.value | number: digitsInfo }}</span>
                      <span class="stat-pct ms-1 fs-14 fw-semibold"
                            [ngClass]=" {
                                          'text-success': (sec.profitUpIsGood && sec.profit==='up'  ) || (!sec.profitUpIsGood && sec.profit==='down'),
                                          'text-danger' : (sec.profitUpIsGood && sec.profit==='down') || (!sec.profitUpIsGood && sec.profit==='up'  ),
                                          'text-muted'  : sec.profit==='equal'
                                        }">
                        <i class="align-middle" [ngClass]=" {'ri-arrow-right-up-line': sec.profit === 'up', 'ri-arrow-right-down-line': sec.profit === 'down'}"></i>
                        @if (sec.profit == 'up' || sec.profit == 'equal') {
                          <span>+</span>
                        }
                        {{sec.percentage}} %
                      </span>
                    </span>
                  </span>
                }
              </h4>
            }
            <a [routerLink]="link" class="link-secondary">{{linkText}}</a>
          </div>

          @if ((secondaries?.length ?? 0) <= 1) {
          <div class="avatar-sm flex-shrink-0">
            <!-- Icon Container Colour-->
            <span
              class="avatar-title rounded fs-3"
              [ngClass]="iconColour ? 'bg-transparent' : {
                            'bg-danger'        : icon === 'bi bi-award-fill' ||
                                                 icon === 'bi bi-bookmark-x' ||
                                                 icon === 'bi bi-exclamation-triangle' ||
                                                 icon === 'bi bi-exclamation-triangle-fill' ||
                                                 icon === 'bi bi-exclamation-circle' ||
                                                 icon === 'bi bi-exclamation-circle-fill',
                            'bg-info'          : icon === 'bi bi-sim' ||
                                                 icon === 'bi bi-award',
                            'bg-info-subtle'   : icon === 'bx-shopping-bag',
                            'bg-primary'       : icon === 'bxs-building' ||
                                                 icon === 'bi bi-tablet',
                            'bg-primary-subtle': icon === 'bx-wallet' ||
                                                 icon === 'bx-phone',
                            'bg-success'       : icon === 'bi bi-bookmark-check' ||
                                                 icon === 'bi bi-check-circle' ||
                                                 icon === 'bxs-business' ||
                                                 icon === 'bx-pound',
                            'bg-success-subtle': icon === 'bx-dollar-circle',
                            'bg-warning'       : icon === 'bx-battery' ||
                                                 icon === 'bx-line-chart',
                            'bg-warning-subtle': icon === 'bx-user-circle',
                          }">
              <!-- Text/Icon Colour-->
              <i
                class="bx {{icon}}"
                [ngClass]="iconColour ? ('text-' + iconColour) : {
                              'text-info'   : icon === 'bx-shopping-bag' || icon === 'bx-phone',
                              'text-primary': icon === 'bx-wallet',
                              'text-success': icon === 'bx-dollar-circle',
                              'text-warning': icon === 'bx-user-circle',
                            }"></i>
            </span>
          </div>
          }
        </div>
      </div>
    </div>
  </div>
}
